import { render, staticRenderFns } from "./userJournal.vue?vue&type=template&id=9873d13c&scoped=true&"
import script from "./userJournal.vue?vue&type=script&lang=js&"
export * from "./userJournal.vue?vue&type=script&lang=js&"
import style0 from "./userJournal.vue?vue&type=style&index=0&id=9873d13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9873d13c",
  null
  
)

export default component.exports